import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {mapboxToken: String, fetchPolygonsUrl: String};

  static targets = [
    "map",
    "selectPeriodInput"
  ]

  #mapboxgl
  #map
  #selectPeriodInputController

  initialize() {
    import("!mapbox-gl").then(
      ((mapboxgl) => {
        this.#mapboxgl = mapboxgl.default;
        this.#mapboxgl.accessToken = this.mapboxTokenValue;
        this.initMap();
      }).bind(this)
    );
  }

  connect() {
    this.selectPeriodInputTarget.addEventListener("connected", (e) => {
      this.#selectPeriodInputController = e.currentTarget["form--collection-select--component"];
    })
  }

  initMap() {
    this.#map = new this.#mapboxgl.Map({
      container: "polygons-map",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [2.2508, 47.1539],
      zoom: 5,
    });

    this.#map.addControl(new this.#mapboxgl.FullscreenControl(), 'top-right');

    this.#map.on('load', () => {
      this.fetchPolygons()
    });
  }

  fetchPolygons() {
    const url = new URL(this.fetchPolygonsUrlValue);
    if (this.#selectPeriodInputController.value) {
      const [beginRaw, endRaw] = this.#selectPeriodInputController.value.split(',');
      const period_begin = encodeURIComponent(beginRaw.trim());
      const period_end = encodeURIComponent(endRaw.trim());
      url.searchParams.set('period_begin', period_begin);
      url.searchParams.set('period_end', period_end);
    }
    fetch(url.toString())
      .then(res => res.json())
      .then(data => {
        if (this.#map.getLayer('zone-labels')) {
          this.#map.removeLayer('zone-labels');
        }
        if (this.#map.getLayer('multipolygon-layer')) {
          this.#map.removeLayer('multipolygon-layer');
        }
        if (this.#map.getSource('multipolygons')) {
          this.#map.removeSource('multipolygons');
        }

        this.#map.addSource('multipolygons', {
          type: 'geojson',
          data: data
        });

        this.#map.addLayer({
          id: 'multipolygon-layer',
          type: 'fill',
          source: 'multipolygons',
          paint: {
            'fill-color': ['get', 'color'],
            'fill-opacity': 0.5
          }
        });

        this.#map.addLayer({
          id: 'zone-labels',
          type: 'symbol',
          source: 'multipolygons',
          layout: {
            'text-field': ['get', 'label'],
            'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
            'text-size': 12,
            'text-allow-overlap': true
          },
          paint: {
            'text-color': '#000',
            'text-halo-color': '#fff',
            'text-halo-width': 1
          }
        });
        if (data.features.length > 0) {
          const bounds = new this.#mapboxgl.LngLatBounds();
          data.features.forEach(feature => {
            const rings = feature.geometry.coordinates.flat(2); // flatten to [ [lng, lat], ... ]
            rings.forEach(coord => {
              if (Array.isArray(coord) && coord.length === 2) {
                bounds.extend(coord);
              }
            });
          });
          this.#map.fitBounds(bounds, {
            padding: 40
          });
        }
      });
  }
}
